import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { PaymentMethodsScreen } from '../PaymentMethodsScreen'
import { useSIPContext } from '../../../state-management/contexts/SIPContext'
import { useMetaDataContext } from '../../../state-management/contexts/MetaDataContext'
import { PaymentPageType } from '../../../types/mf-execution.types'
import { parseAmountFromQueryParam } from '../../../utils/mf-execution/paymentAmount'
import { isUpiIntentsFlowEnabled } from '../../../utils/mf-execution/upiIntentsFeature'
import { EventNames } from '../../../types/misc.types'
import { trackEvent } from '../../../utils/appBridge'

export default function SIPPaymentMethodsScreen() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { isin, data: metaData } = useMetaDataContext()
  const amount = parseAmountFromQueryParam(searchParams)
  const {
    handleAmountChange,
    paymentMethods,
    bankAccountDetails,
    defaultPaymentMethodDetails,
    selectedPaymentMethod,
    handlePaymentMethodChange,
    handleRefetchPaymentMethods,
    installedUpiApps,
    requestUpiIntents,
    calendarSelection,
    upiIntentMaximumAllowedAmount
  } = useSIPContext()

  const fundName = metaData?.fundDetails?.fundName ?? ''
  const trackingFund = isin && fundName ? { fundIsin: isin, fundName } : undefined

  useEffect(() => {
    if (!isUpiIntentsFlowEnabled()) {
      navigate(-1)
    }
  }, [navigate])

  useEffect(() => {
    if (amount > 0) {
      handleAmountChange(amount)
    }
  }, [amount, handleAmountChange])

  return (
    <PaymentMethodsScreen
      amount={amount}
      isin={isin ?? ''}
      paymentPageType={PaymentPageType.SIP}
      upiIntentMaximumAllowedAmount={upiIntentMaximumAllowedAmount}
      paymentMethods={paymentMethods}
      bankAccountDetails={bankAccountDetails}
      defaultPaymentMethodDetails={defaultPaymentMethodDetails}
      selectedPaymentMethod={selectedPaymentMethod}
      onPaymentMethodChange={handlePaymentMethodChange}
      onRefetchPaymentMethods={handleRefetchPaymentMethods}
      installedUpiApps={installedUpiApps}
      requestUpiIntents={requestUpiIntents}
      isConfirmBlocked={!calendarSelection}
      onConfirm={() => {
        trackEvent({
          eventName: EventNames.ButtonTap,
          payload: {
            ScreenName: 'Select payment method',
            buttonLabel: 'Confirm',
            eventId: 'MFE_SELECT_PAYMENT_METHOD_CTA_CONFIRM',
            ...(trackingFund ?? {})
          }
        })
      }}
    />
  )
}
